import React from 'react';

import Brand from '@rover/components/src/microdata/Brand';
import schema from '@rover/components/src/microdata/schema';
import A11yHiddenBox from '@rover/kibble/styles/A11yHiddenBox';
import type { CountryConfiguration } from '@rover/rsdk/src/apiClient/latest/model/countryConfiguration';

import LandingHelmet from '../../components/LandingHelmet';

type Props = {
  seoTitle: string;
  seoMetaDescription: string;
  serviceTypeName: string;
  brandName: string;
  h1: string;
  h2: string;
  countryConfig: Pick<CountryConfiguration, 'urls'>;
  indexable: boolean;
  children?: React.ReactNode;
};

const ServiceLandingPageWrapper: React.FC<Props> = ({
  seoTitle,
  seoMetaDescription,
  serviceTypeName,
  brandName,
  h1,
  h2,
  countryConfig,
  indexable,
  children,
}) => {
  return (
    <>
      <LandingHelmet title={seoTitle} metaDescription={seoMetaDescription} indexable={indexable} />
      <A11yHiddenBox>
        <div itemScope itemType={schema`Service`}>
          <Brand itemProp="brand" indexUrl={countryConfig.urls.indexUrl} name={brandName} />
          <meta itemProp="name" content={serviceTypeName} />
          <meta itemProp="category" content={serviceTypeName} />
          <meta itemProp="serviceType" content={h1} />
          <meta itemProp="description" content={h2} />
          <meta itemProp="termsOfService" content={countryConfig.urls.tosUrl} />
        </div>
      </A11yHiddenBox>
      {children}
    </>
  );
};

export default ServiceLandingPageWrapper;
